import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=9c81423c&scoped=true&"
import script from "./contactForm.vue?vue&type=script&lang=js&"
export * from "./contactForm.vue?vue&type=script&lang=js&"
import style0 from "./contactForm.vue?vue&type=style&index=0&id=9c81423c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c81423c",
  null
  
)

/* custom blocks */
import block0 from "./contactForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports